import { TelehealthContext } from '@/context/TelehealthContext';
import { useContext } from 'react';

const useTelehealth = () => {
  const telehealthContext = useContext(TelehealthContext);
  if (telehealthContext === undefined) throw 'Wrap the provider!';

  return telehealthContext;
};

export default useTelehealth;
